import { Outlet } from "react-router"
import {
	Stack,
	Tabs,
	TabsList,
	TabContent,
	Heading,
	Container,
	Inline,
} from "@sembark-travel/ui-base"
import { NavLink } from "@sembark-travel/ui-router"
import { generatePath } from "../../../../../router-utils"

export default function Layout() {
	return (
		<Stack gap="4">
			<Container>
				<Heading>Tourists</Heading>
			</Container>
			<Tabs layout="col" gap="6">
				<TabsList>
					<NavLink to={generatePath("/org/tourists/all")}>All</NavLink>
					<NavLink to={generatePath("/org/tourists/profiles")}>
						<Inline gap="1" alignItems="center">
							Tourist Profiles
						</Inline>
					</NavLink>
				</TabsList>
				<TabContent>
					<Outlet />
				</TabContent>
			</Tabs>
		</Stack>
	)
}
